// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1uh1Z","alert":"SettungsInbox_alert__2Uj5E"};